module.exports = __webpack_public_path__ + "img/educationalGroupMedia.015fd538.svg";